define('app/filters/controls/TimespanFilterControl',['require','glu/itemView','app/visualizations/FormatFactory','glu/util','hbs!./TimespanFilterControl.hbs'],function(require) {
	'use strict';

	var ItemView = require('glu/itemView');
	var FormatFactory = require('app/visualizations/FormatFactory');
	var _ = require('glu/util');

	// the number of seconds in a minutes
	// the time values are stored in seconds and UI is using minutes as the smallest unit
	// we need to convert them back and forth
	var minuteStr = 'minutes';
	var hourStr = 'hours';
	var dayStr = 'days';

	var secsInMins = 60;
	var minutes = secsInMins; // seconds
	var hours = 60 * minutes; //seconds
	var days = 24 * hours; //seconds

	return ItemView.extend({

		template: require('hbs!./TimespanFilterControl.hbs'),

		ui: {
			$minVal: '[name=minValue]',
			$maxVal: '[name=maxValue]',
			$minUnit: '[name=minUnit]',
			$maxUnit: '[name=maxUnit]',
			$errorMsg: '[id=errorMsg]'
		},

		events: {
			'change [name=minValue]': 'updateModel',
			'change [name=maxValue]': 'updateModel',
			'keyup [name=minValue]': 'updateModel',
			'keyup [name=maxValue]': 'updateModel',
			'change [name=minUnit]': 'updateModel',
			'change [name=maxUnit]': 'updateModel'
		},

		serializeData: function() {
			return this;
		},

		initOperationMode: function() {
			var mode; // 'in between', 'gt', 'lt'
			var arity;
			var dts1, dts2;

			var op = this.model.getOperator();
			if (op === 'LT') {
				mode = 'less';
				arity = 1;
				dts1 = dts2 = this.model.getValue(0);
			} else if (op === 'GT') {
				mode = 'greater';
				arity = 1;
				dts1 = dts2 = this.model.getValue(0);
			} else if (op === 'EQ') {
				mode = 'equal';
				arity = 1;
				dts1 = dts2 = this.model.getValue(0);
			} else if (op === 'NEQ') {
				mode = 'nequal';
				arity = 1;
				dts1 = dts2 = this.model.getValue(0);
			} else if (op === 'ISNULL') {
				mode = 'isnull';
				arity = 0;
			} else if (op === 'NISNULL') {
				mode = 'nisnull';
				arity = 0;
			} else if (op === 'BETWEEN_GTE_LTE') {
				mode = 'between';
				arity = 2;
				dts1 = this.model.getValue(0);
				dts2 = this.model.getValue(1);
			} else {
				throw new Error('Unknown operator "' + op + '"');
			}
			this.operationMode = {
				mode: mode,
				arity: arity,
				dts1: dts1,
				dts2: dts2,
				unit: ['minutes', 'minutes']
			};
		},

		initialize: function() {
			this.initOperationMode();

			//change operator arity, depending on 'mode'
			this.model.setArity(this.operationMode.arity);
		},

		isInBetween: function() {
			if (this.operationMode.mode === 'between') {
				return true;
			}
			return false;
		},


		hasInput: function() {
			if (this.operationMode.arity > 0) {
				return true;
			}
			return false;
		},

		minValue: function() {
			var value = this.model.getValue(0);
			return (value === null || value === undefined) ? null : this.nearestUnit(0, value);
		},

		maxValue: function() {
			var value = this.model.getValue(1);
			return (value === null || value === undefined) ? null : this.nearestUnit(1, value);
		},


		minLabel: function() {
			var value = this.model.getValue(0);
			var format = FormatFactory.formatterForType(this.model.type(), {
				enumeration: this.model.enumeration()
			});
			return format(value);
		},

		maxLabel: function() {
			var value = this.model.getValue(1);
			var format = FormatFactory.formatterForType(this.model.type(), {
				enumeration: this.model.enumeration()
			});
			return format(value);
		},

		isBothZero: function() {
			return this.minValue() === 0 && this.maxValue() === 0;
		},

		isMinMinute: function() {
			if (this.isBothZero()) {
				return true;
			}

			if (this.minValue() === 0) {
				return this.isMaxMinute();
			} else {
				return (this.operationMode.unit[0] === minuteStr);
			}
		},

		isMaxMinute: function() {
			if (this.isBothZero()) {
				return true;
			}

			if (this.maxValue() === 0) {
				return this.isMinMinute();
			} else {
				return (this.operationMode.unit[1] === minuteStr);
			}
		},

		isMinHour: function() {
			if (this.isBothZero()) {
				return false;
			}

			if (this.minValue() === 0) {
				return this.isMaxHour();
			} else {
				return (this.operationMode.unit[0] === hourStr);
			}
		},

		isMaxHour: function() {
			if (this.isBothZero()) {
				return false;
			}

			if (this.maxValue() === 0) {
				return this.isMinHour();
			} else {
				return (this.operationMode.unit[1] === hourStr);
			}
		},

		isMinDay: function() {
			if (this.isBothZero()) {
				return false;
			}
			if (this.minValue() === 0) {
				return this.isMaxDay();
			} else {
				return (this.operationMode.unit[0] === dayStr);
			}
		},

		isMaxDay: function() {
			if (this.isBothZero()) {
				return false;
			}

			if (this.maxValue() === 0) {
				return this.isMinDay();
			} else {
				return (this.operationMode.unit[1] === dayStr);
			}
		},

		minSelectableOptions: function() {
			var self = this;
			var selectableOptions = this.possibleValues();

			_.each(selectableOptions, function(pv) {
				_.extend(pv, {
					isSelected: self.minValue() === pv.value
				});
			});

			return selectableOptions;
		},

		maxSelectableOptions: function() {
			var self = this;
			var selectableOptions = this.possibleValues();

			_.each(selectableOptions, function(pv) {
				_.extend(pv, {
					isSelected: self.maxValue() === pv.value
				});
			});

			return selectableOptions;
		},

		nearestUnit: function(index, value) {

			var val = value;
			if (!isNaN(value)) {
				if (value % days === 0) {
					val = value / days;
					this.operationMode.unit[index] = dayStr;
				} else if (value % hours === 0) {
					val = value / hours;
					this.operationMode.unit[index] = hourStr;
				} else { // minutes
					val = value / minutes;
					this.operationMode.unit[index] = minuteStr;
				}
			}
			return val;
		},

		convertToSeconds: function(unit, value) {

			if (unit === minuteStr) {
				return (value * minutes);
			}
			if (unit === hourStr) {
				return (value * hours);
			}
			if (unit === dayStr) {
				return (value * days);
			}
			return value;
		},

		convertValues: function(minInputUnit, minInputValue, maxInputUnit, maxInputValue) {
			var minValue = parseFloat(minInputValue);
			var maxValue = parseFloat(maxInputValue);

			// timespan is in seconds, so conversion happens here
			if (this.hasInput()) {
				minValue = this.convertToSeconds(minInputUnit, minValue);
				this.model.setValue(0, minInputValue.length === 0 || isNaN(minInputValue) ? null : minValue);

				if (this.isInBetween()) {
					maxValue = this.convertToSeconds(maxInputUnit, maxValue);
					this.model.setValue(1, maxInputValue.length === 0 || isNaN(maxInputValue) ? null : maxValue);
				}
			}
		},

		updateModel: function() {
			var minInputValue = this.ui.$minVal.val();
			var maxInputValue = this.ui.$maxVal.val();
			var minInputUnit = this.ui.$minUnit.val();
			var maxInputUnit = this.ui.$maxUnit.val();

			if ((minInputValue && isNaN(minInputValue)) || (maxInputValue && isNaN(maxInputValue))) {
				this.ui.$errorMsg.show();
			} else {
				this.ui.$errorMsg.hide();
			}

			// validate the fields
			if (isNaN(minInputValue)) {
				this.ui.$minVal.addClass('input-dialog-item-error');
			} else {
				this.ui.$minVal.removeClass('input-dialog-item-error');
			}

			if (isNaN(maxInputValue)) {
				this.ui.$maxVal.addClass('input-dialog-item-error');
			} else {
				this.ui.$maxVal.removeClass('input-dialog-item-error');
			}

			// timespan is in seconds, so conversion happens here
			this.operationMode.unit[0] = minInputUnit;
			this.operationMode.unit[1] = maxInputUnit;
			this.convertValues(minInputUnit, minInputValue, maxInputUnit, maxInputValue);
		}
	});

});

